import { Alert, Box, Button, Skeleton, Text } from '@nimbus-ds/components';
import { Layout, Page } from '@nimbus-ds/patterns';
import { IonPageStratus } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

function OrdersAutoCancelPageSkeleton() {
  const t = useTranslationOrders('autoCancel');

  return (
    <IonPageStratus width="small">
      <Page.Header title={t('title')}>
        <Text.Skeleton width="100%" height="40px" />
        <Alert.Skeleton height="80px" />
      </Page.Header>
      <Page.Body>
        <Layout columns="1">
          <Layout.Section>
            <Skeleton height="132px" width="100%" borderRadius="10px" />

            <Skeleton height="124px" width="100%" borderRadius="10px" />
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="flex-end"
              gap="2"
            >
              <Button.Skeleton key="skeleton-cancel" />
              <Button.Skeleton key="skeleton-save" />
            </Box>
          </Layout.Section>
        </Layout>
      </Page.Body>
    </IonPageStratus>
  );
}

export default OrdersAutoCancelPageSkeleton;
